import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Reveal";

const SPECS = [
  ["Type", "Self-feeding slow masticating juicer"],
  ["Feed chute", "Large-diameter, takes whole produce"],
  ["Materials", "BPA-free (No Bisphenol-A)"],
  ["Cleaning", "Quick-rinse design, seconds to clean"],
  ["Assembly", "Tool-free, click-together parts"],
  ["Finish", "Matte black with smoked hopper"],
];
const BOX = ["The Slowpour 01 juicer", "Juice cup", "Pulp cup", "Recipe Almanac (PDF, emailed link)"];
const FAQ = [
  ["How much is shipping and tax?", "Shipping is a flat $15 per order, anywhere in the US. Sales tax is 8.85% (Alton, IL rate) on the juicer. You'll see the full breakdown before you pay."],
  ["When will my juicer ship?", "Orders ship from Alton, Illinois within 1–2 business days. Delivery typically takes 3–7 business days."],
  ["How do I get the Recipe Almanac?", "Right after your payment is confirmed you'll land on a confirmation page with an instant PDF download."],
  ["Can I split my payment?", "Yes. At checkout you can pay in 4 interest-free installments with Klarna or Afterpay, or choose monthly payments with Affirm (subject to approval by the provider)."],
  ["Is checkout secure?", "Yes. Payments are processed by Stripe — we never see or store your card details."],
  ["What's the difference between slow and fast juicers?", "Fast centrifugal juicers spin a blade at high speed which adds heat and foam. A slow masticating juicer gently crushes and presses produce for richer, smoother juice and drier pulp."],
  ["Who created the recipes?", "Kathryn, our Juice Alchemist, created and tested all 12 recipes in The Recipe Almanac on the Slowpour 01."],
];

export const Specs = () => (
  <section id="specs" data-testid="specs-section" className="border-t border-[#E3D9CD] bg-[#FDFBF7] py-20 sm:py-28">
    <div className="mx-auto grid max-w-[1400px] gap-16 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow mb-4 text-[#C85A32]">Specifications</p>
        <h2 className="font-display text-4xl font-light tracking-tight sm:text-5xl">The details.</h2>
        <dl className="mt-10 divide-y divide-[#E3D9CD] border-y border-[#E3D9CD]">
          {SPECS.map(([k, v]) => (
            <div key={k} className="flex justify-between gap-6 py-4 text-sm">
              <dt className="eyebrow text-[0.65rem] text-[#6E6661]">{k}</dt>
              <dd className="text-right text-[#181615]">{v}</dd>
            </div>
          ))}
        </dl>
        <p className="eyebrow mb-4 mt-10 text-[#6E6661]">In the box</p>
        <ul className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
          {BOX.map((b) => <li key={b} className="rounded-full border border-[#E3D9CD] px-4 py-2">{b}</li>)}
        </ul>
      </Reveal>
      <Reveal id="faq" className="lg:col-span-6 lg:col-start-7" delay={0.1}>
        <div id="faq" data-testid="faq-section">
          <p className="eyebrow mb-4 text-[#C85A32]">Good to know</p>
          <h2 className="font-display text-4xl font-light tracking-tight sm:text-5xl">Questions, answered.</h2>
          <Accordion type="single" collapsible className="mt-8">
            {FAQ.map(([q, a], i) => (
              <AccordionItem key={q} value={`f${i}`} className="border-[#E3D9CD]">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display py-5 text-left text-lg font-normal hover:no-underline">{q}</AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-[#4A4543]">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Reveal>
    </div>
  </section>
);
